import { DeepReadonly } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';
import { countryCodes } from './countryCodes.js';

/**
 * Country phone codes mapping (ISO 3166-1 alpha-2 to phone code)
 * Used for phone number input components
 */
export const countryPhoneCodes: DeepReadonly<Record<string, string>> = deepFreeze({
  [countryCodes.BANGLADESH.alphaTwo]: '880',
  [countryCodes.BELGIUM.alphaTwo]: '32',
  [countryCodes.BURKINA_FASO.alphaTwo]: '226',
  [countryCodes.BULGARIA.alphaTwo]: '359',
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: '387',
  [countryCodes.BARBADOS.alphaTwo]: '1246',
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: '681',
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: '590',
  [countryCodes.BERMUDA.alphaTwo]: '1441',
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: '673',
  [countryCodes.BOLIVIA.alphaTwo]: '591',
  [countryCodes.BAHRAIN.alphaTwo]: '973',
  [countryCodes.BURUNDI.alphaTwo]: '257',
  [countryCodes.BENIN.alphaTwo]: '229',
  [countryCodes.BHUTAN.alphaTwo]: '975',
  [countryCodes.JAMAICA.alphaTwo]: '1876',
  [countryCodes.BOUVET_ISLAND.alphaTwo]: '',
  [countryCodes.BOTSWANA.alphaTwo]: '267',
  [countryCodes.SAMOA.alphaTwo]: '685',
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: '599',
  [countryCodes.BRAZIL.alphaTwo]: '55',
  [countryCodes.BAHAMAS.alphaTwo]: '1242',
  [countryCodes.JERSEY.alphaTwo]: '441534',
  [countryCodes.BELARUS.alphaTwo]: '375',
  [countryCodes.BELIZE.alphaTwo]: '501',
  [countryCodes.RUSSIA.alphaTwo]: '7',
  [countryCodes.RWANDA.alphaTwo]: '250',
  [countryCodes.SERBIA.alphaTwo]: '381',
  [countryCodes.TIMOR_LESTE.alphaTwo]: '670',
  [countryCodes.REUNION.alphaTwo]: '262',
  [countryCodes.TURKMENISTAN.alphaTwo]: '993',
  [countryCodes.TAJIKISTAN.alphaTwo]: '992',
  [countryCodes.ROMANIA.alphaTwo]: '40',
  [countryCodes.TOKELAU.alphaTwo]: '690',
  [countryCodes.GUINEA_BISSAU.alphaTwo]: '245',
  [countryCodes.GUAM.alphaTwo]: '1671',
  [countryCodes.GUATEMALA.alphaTwo]: '502',
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: '',
  [countryCodes.GREECE.alphaTwo]: '30',
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: '240',
  [countryCodes.GUADELOUPE.alphaTwo]: '590',
  [countryCodes.JAPAN.alphaTwo]: '81',
  [countryCodes.GUYANA.alphaTwo]: '592',
  [countryCodes.GUERNSEY.alphaTwo]: '441481',
  [countryCodes.FRENCH_GUIANA.alphaTwo]: '594',
  [countryCodes.GEORGIA.alphaTwo]: '995',
  [countryCodes.GRENADA.alphaTwo]: '1473',
  [countryCodes.UNITED_KINGDOM.alphaTwo]: '44',
  [countryCodes.GABON.alphaTwo]: '241',
  [countryCodes.EL_SALVADOR.alphaTwo]: '503',
  [countryCodes.GUINEA.alphaTwo]: '224',
  [countryCodes.GAMBIA.alphaTwo]: '220',
  [countryCodes.GREENLAND.alphaTwo]: '299',
  [countryCodes.GIBRALTAR.alphaTwo]: '350',
  [countryCodes.GHANA.alphaTwo]: '233',
  [countryCodes.OMAN.alphaTwo]: '968',
  [countryCodes.TUNISIA.alphaTwo]: '216',
  [countryCodes.JORDAN.alphaTwo]: '962',
  [countryCodes.CROATIA.alphaTwo]: '385',
  [countryCodes.HAITI.alphaTwo]: '509',
  [countryCodes.HUNGARY.alphaTwo]: '36',
  [countryCodes.HONG_KONG.alphaTwo]: '852',
  [countryCodes.HONDURAS.alphaTwo]: '504',
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: ' ',
  [countryCodes.VENEZUELA.alphaTwo]: '58',
  [countryCodes.PUERTO_RICO.alphaTwo]: '1787 and 1939',
  [countryCodes.PALESTINE.alphaTwo]: '970',
  [countryCodes.PALAU.alphaTwo]: '680',
  [countryCodes.PORTUGAL.alphaTwo]: '351',
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: '47',
  [countryCodes.PARAGUAY.alphaTwo]: '595',
  [countryCodes.IRAQ.alphaTwo]: '964',
  [countryCodes.PANAMA.alphaTwo]: '507',
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: '689',
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: '675',
  [countryCodes.PERU.alphaTwo]: '51',
  [countryCodes.PAKISTAN.alphaTwo]: '92',
  [countryCodes.PHILIPPINES.alphaTwo]: '63',
  [countryCodes.PITCAIRN.alphaTwo]: '870',
  [countryCodes.POLAND.alphaTwo]: '48',
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: '508',
  [countryCodes.ZAMBIA.alphaTwo]: '260',
  [countryCodes.WESTERN_SAHARA.alphaTwo]: '212',
  [countryCodes.ESTONIA.alphaTwo]: '372',
  [countryCodes.EGYPT.alphaTwo]: '20',
  [countryCodes.SOUTH_AFRICA.alphaTwo]: '27',
  [countryCodes.ECUADOR.alphaTwo]: '593',
  [countryCodes.ITALY.alphaTwo]: '39',
  [countryCodes.VIETNAM.alphaTwo]: '84',
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: '677',
  [countryCodes.ETHIOPIA.alphaTwo]: '251',
  [countryCodes.SOMALIA.alphaTwo]: '252',
  [countryCodes.ZIMBABWE.alphaTwo]: '263',
  [countryCodes.SAUDI_ARABIA.alphaTwo]: '966',
  [countryCodes.SPAIN.alphaTwo]: '34',
  [countryCodes.ERITREA.alphaTwo]: '291',
  [countryCodes.MONTENEGRO.alphaTwo]: '382',
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: '373',
  [countryCodes.MADAGASCAR.alphaTwo]: '261',
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: '590',
  [countryCodes.MOROCCO.alphaTwo]: '212',
  [countryCodes.MONACO.alphaTwo]: '377',
  [countryCodes.UZBEKISTAN.alphaTwo]: '998',
  [countryCodes.MYANMAR.alphaTwo]: '95',
  [countryCodes.MALI.alphaTwo]: '223',
  [countryCodes.MACAU.alphaTwo]: '853',
  [countryCodes.MONGOLIA.alphaTwo]: '976',
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: '692',
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: '389',
  [countryCodes.MAURITIUS.alphaTwo]: '230',
  [countryCodes.MALTA.alphaTwo]: '356',
  [countryCodes.MALAWI.alphaTwo]: '265',
  [countryCodes.MALDIVES.alphaTwo]: '960',
  [countryCodes.MARTINIQUE.alphaTwo]: '596',
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: '1670',
  [countryCodes.MONTSERRAT.alphaTwo]: '1664',
  [countryCodes.MAURITANIA.alphaTwo]: '222',
  [countryCodes.ISLE_OF_MAN.alphaTwo]: '441624',
  [countryCodes.UGANDA.alphaTwo]: '256',
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: '255',
  [countryCodes.MALAYSIA.alphaTwo]: '60',
  [countryCodes.MEXICO.alphaTwo]: '52',
  [countryCodes.ISRAEL.alphaTwo]: '972',
  [countryCodes.FRANCE.alphaTwo]: '33',
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: '246',
  [countryCodes.SAINT_HELENA.alphaTwo]: '290',
  [countryCodes.FINLAND.alphaTwo]: '358',
  [countryCodes.FIJI.alphaTwo]: '679',
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: '500',
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: '691',
  [countryCodes.FAROE_ISLANDS.alphaTwo]: '298',
  [countryCodes.NICARAGUA.alphaTwo]: '505',
  [countryCodes.NETHERLANDS.alphaTwo]: '31',
  [countryCodes.NORWAY.alphaTwo]: '47',
  [countryCodes.NAMIBIA.alphaTwo]: '264',
  [countryCodes.VANUATU.alphaTwo]: '678',
  [countryCodes.NEW_CALEDONIA.alphaTwo]: '687',
  [countryCodes.NIGER.alphaTwo]: '227',
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: '672',
  [countryCodes.NIGERIA.alphaTwo]: '234',
  [countryCodes.NEW_ZEALAND.alphaTwo]: '64',
  [countryCodes.NEPAL.alphaTwo]: '977',
  [countryCodes.NAURU.alphaTwo]: '674',
  [countryCodes.NIUE.alphaTwo]: '683',
  [countryCodes.COOK_ISLANDS.alphaTwo]: '682',
  [countryCodes.KOSOVO.alphaTwo]: '',
  [countryCodes.COTE_DIVOIRE.alphaTwo]: '225',
  [countryCodes.SWITZERLAND.alphaTwo]: '41',
  [countryCodes.COLOMBIA.alphaTwo]: '57',
  [countryCodes.CHINA.alphaTwo]: '86',
  [countryCodes.CAMEROON.alphaTwo]: '237',
  [countryCodes.CHILE.alphaTwo]: '56',
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: '61',
  [countryCodes.CANADA.alphaTwo]: '1',
  [countryCodes.CONGO.alphaTwo]: '242',
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: '236',
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: '243',
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: '420',
  [countryCodes.CYPRUS.alphaTwo]: '357',
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: '61',
  [countryCodes.COSTA_RICA.alphaTwo]: '506',
  [countryCodes.CURACAO.alphaTwo]: '599',
  [countryCodes.CAPE_VERDE.alphaTwo]: '238',
  [countryCodes.CUBA.alphaTwo]: '53',
  [countryCodes.SWAZILAND.alphaTwo]: '268',
  [countryCodes.SYRIA.alphaTwo]: '963',
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: '599',
  [countryCodes.KYRGYZSTAN.alphaTwo]: '996',
  [countryCodes.KENYA.alphaTwo]: '254',
  [countryCodes.SOUTH_SUDAN.alphaTwo]: '211',
  [countryCodes.SURINAME.alphaTwo]: '597',
  [countryCodes.KIRIBATI.alphaTwo]: '686',
  [countryCodes.CAMBODIA.alphaTwo]: '855',
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: '1869',
  [countryCodes.COMOROS.alphaTwo]: '269',
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: '239',
  [countryCodes.SLOVAKIA.alphaTwo]: '421',
  [countryCodes.SOUTH_KOREA.alphaTwo]: '82',
  [countryCodes.SLOVENIA.alphaTwo]: '386',
  [countryCodes.NORTH_KOREA.alphaTwo]: '850',
  [countryCodes.KUWAIT.alphaTwo]: '965',
  [countryCodes.SENEGAL.alphaTwo]: '221',
  [countryCodes.SAN_MARINO.alphaTwo]: '378',
  [countryCodes.SIERRA_LEONE.alphaTwo]: '232',
  [countryCodes.SEYCHELLES.alphaTwo]: '248',
  [countryCodes.KAZAKHSTAN.alphaTwo]: '7',
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: '1345',
  [countryCodes.SINGAPORE.alphaTwo]: '65',
  [countryCodes.SWEDEN.alphaTwo]: '46',
  [countryCodes.SUDAN.alphaTwo]: '249',
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: '1809 and 1829',
  [countryCodes.DOMINICA.alphaTwo]: '1767',
  [countryCodes.DJIBOUTI.alphaTwo]: '253',
  [countryCodes.DENMARK.alphaTwo]: '45',
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: '1284',
  [countryCodes.GERMANY.alphaTwo]: '49',
  [countryCodes.YEMEN.alphaTwo]: '967',
  [countryCodes.ALGERIA.alphaTwo]: '213',
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: '1',
  [countryCodes.URUGUAY.alphaTwo]: '598',
  [countryCodes.MAYOTTE.alphaTwo]: '262',
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: '1',
  [countryCodes.LEBANON.alphaTwo]: '961',
  [countryCodes.SAINT_LUCIA.alphaTwo]: '1758',
  [countryCodes.LAOS.alphaTwo]: '856',
  [countryCodes.TUVALU.alphaTwo]: '688',
  [countryCodes.TAIWAN.alphaTwo]: '886',
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: '1868',
  [countryCodes.TURKEY.alphaTwo]: '90',
  [countryCodes.SRI_LANKA.alphaTwo]: '94',
  [countryCodes.LIECHTENSTEIN.alphaTwo]: '423',
  [countryCodes.LATVIA.alphaTwo]: '371',
  [countryCodes.TONGA.alphaTwo]: '676',
  [countryCodes.LITHUANIA.alphaTwo]: '370',
  [countryCodes.LUXEMBOURG.alphaTwo]: '352',
  [countryCodes.LIBERIA.alphaTwo]: '231',
  [countryCodes.LESOTHO.alphaTwo]: '266',
  [countryCodes.THAILAND.alphaTwo]: '66',
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: '',
  [countryCodes.TOGO.alphaTwo]: '228',
  [countryCodes.CHAD.alphaTwo]: '235',
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: '1649',
  [countryCodes.LIBYA.alphaTwo]: '218',
  [countryCodes.VATICAN.alphaTwo]: '379',
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: '1784',
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: '971',
  [countryCodes.ANDORRA.alphaTwo]: '376',
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: '1268',
  [countryCodes.AFGHANISTAN.alphaTwo]: '93',
  [countryCodes.ANGUILLA.alphaTwo]: '1264',
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: '1340',
  [countryCodes.ICELAND.alphaTwo]: '354',
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: '98',
  [countryCodes.ARMENIA.alphaTwo]: '374',
  [countryCodes.ALBANIA.alphaTwo]: '355',
  [countryCodes.ANGOLA.alphaTwo]: '244',
  [countryCodes.ANTARCTICA.alphaTwo]: '',
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: '1684',
  [countryCodes.ARGENTINA.alphaTwo]: '54',
  [countryCodes.AUSTRALIA.alphaTwo]: '61',
  [countryCodes.AUSTRIA.alphaTwo]: '43',
  [countryCodes.ARUBA.alphaTwo]: '297',
  [countryCodes.INDIA.alphaTwo]: '91',
  [countryCodes.ALAND_ISLANDS.alphaTwo]: '35818',
  [countryCodes.AZERBAIJAN.alphaTwo]: '994',
  [countryCodes.IRELAND.alphaTwo]: '353',
  [countryCodes.INDONESIA.alphaTwo]: '62',
  [countryCodes.UKRAINE.alphaTwo]: '380',
  [countryCodes.QATAR.alphaTwo]: '974',
  [countryCodes.MOZAMBIQUE.alphaTwo]: '258',
});

/**
 * Country names mapping (ISO 3166-1 alpha-2 to country name)
 * Used for phone number input components
 *
 * Differs from the recognised country names in some cases (e.g., "Timor-Leste" vs "East Timor")
 */
export const countryNames: DeepReadonly<Record<string, string>> = deepFreeze({
  [countryCodes.BANGLADESH.alphaTwo]: 'Bangladesh',
  [countryCodes.BELGIUM.alphaTwo]: 'Belgium',
  [countryCodes.BURKINA_FASO.alphaTwo]: 'Burkina Faso',
  [countryCodes.BULGARIA.alphaTwo]: 'Bulgaria',
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: 'Bosnia and Herzegovina',
  [countryCodes.BARBADOS.alphaTwo]: 'Barbados',
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: 'Wallis and Futuna',
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: 'Saint Barthelemy',
  [countryCodes.BERMUDA.alphaTwo]: 'Bermuda',
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: 'Brunei',
  [countryCodes.BOLIVIA.alphaTwo]: 'Bolivia',
  [countryCodes.BAHRAIN.alphaTwo]: 'Bahrain',
  [countryCodes.BURUNDI.alphaTwo]: 'Burundi',
  [countryCodes.BENIN.alphaTwo]: 'Benin',
  [countryCodes.BHUTAN.alphaTwo]: 'Bhutan',
  [countryCodes.JAMAICA.alphaTwo]: 'Jamaica',
  [countryCodes.BOUVET_ISLAND.alphaTwo]: 'Bouvet Island',
  [countryCodes.BOTSWANA.alphaTwo]: 'Botswana',
  [countryCodes.SAMOA.alphaTwo]: 'Samoa',
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: 'Bonaire, Saint Eustatius and Saba ',
  [countryCodes.BRAZIL.alphaTwo]: 'Brazil',
  [countryCodes.BAHAMAS.alphaTwo]: 'Bahamas',
  [countryCodes.JERSEY.alphaTwo]: 'Jersey',
  [countryCodes.BELARUS.alphaTwo]: 'Belarus',
  [countryCodes.BELIZE.alphaTwo]: 'Belize',
  [countryCodes.RUSSIA.alphaTwo]: 'Russia',
  [countryCodes.RWANDA.alphaTwo]: 'Rwanda',
  [countryCodes.SERBIA.alphaTwo]: 'Serbia',
  [countryCodes.TIMOR_LESTE.alphaTwo]: 'East Timor',
  [countryCodes.REUNION.alphaTwo]: 'Reunion',
  [countryCodes.TURKMENISTAN.alphaTwo]: 'Turkmenistan',
  [countryCodes.TAJIKISTAN.alphaTwo]: 'Tajikistan',
  [countryCodes.ROMANIA.alphaTwo]: 'Romania',
  [countryCodes.TOKELAU.alphaTwo]: 'Tokelau',
  [countryCodes.GUINEA_BISSAU.alphaTwo]: 'Guinea-Bissau',
  [countryCodes.GUAM.alphaTwo]: 'Guam',
  [countryCodes.GUATEMALA.alphaTwo]: 'Guatemala',
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: 'South Georgia and the South Sandwich Islands',
  [countryCodes.GREECE.alphaTwo]: 'Greece',
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: 'Equatorial Guinea',
  [countryCodes.GUADELOUPE.alphaTwo]: 'Guadeloupe',
  [countryCodes.JAPAN.alphaTwo]: 'Japan',
  [countryCodes.GUYANA.alphaTwo]: 'Guyana',
  [countryCodes.GUERNSEY.alphaTwo]: 'Guernsey',
  [countryCodes.FRENCH_GUIANA.alphaTwo]: 'French Guiana',
  [countryCodes.GEORGIA.alphaTwo]: 'Georgia',
  [countryCodes.GRENADA.alphaTwo]: 'Grenada',
  [countryCodes.UNITED_KINGDOM.alphaTwo]: 'United Kingdom',
  [countryCodes.GABON.alphaTwo]: 'Gabon',
  [countryCodes.EL_SALVADOR.alphaTwo]: 'El Salvador',
  [countryCodes.GUINEA.alphaTwo]: 'Guinea',
  [countryCodes.GAMBIA.alphaTwo]: 'Gambia',
  [countryCodes.GREENLAND.alphaTwo]: 'Greenland',
  [countryCodes.GIBRALTAR.alphaTwo]: 'Gibraltar',
  [countryCodes.GHANA.alphaTwo]: 'Ghana',
  [countryCodes.OMAN.alphaTwo]: 'Oman',
  [countryCodes.TUNISIA.alphaTwo]: 'Tunisia',
  [countryCodes.JORDAN.alphaTwo]: 'Jordan',
  [countryCodes.CROATIA.alphaTwo]: 'Croatia',
  [countryCodes.HAITI.alphaTwo]: 'Haiti',
  [countryCodes.HUNGARY.alphaTwo]: 'Hungary',
  [countryCodes.HONG_KONG.alphaTwo]: 'Hong Kong',
  [countryCodes.HONDURAS.alphaTwo]: 'Honduras',
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: 'Heard Island and McDonald Islands',
  [countryCodes.VENEZUELA.alphaTwo]: 'Venezuela',
  [countryCodes.PUERTO_RICO.alphaTwo]: 'Puerto Rico',
  [countryCodes.PALESTINE.alphaTwo]: 'Palestinian Territory',
  [countryCodes.PALAU.alphaTwo]: 'Palau',
  [countryCodes.PORTUGAL.alphaTwo]: 'Portugal',
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: 'Svalbard and Jan Mayen',
  [countryCodes.PARAGUAY.alphaTwo]: 'Paraguay',
  [countryCodes.IRAQ.alphaTwo]: 'Iraq',
  [countryCodes.PANAMA.alphaTwo]: 'Panama',
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: 'French Polynesia',
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: 'Papua New Guinea',
  [countryCodes.PERU.alphaTwo]: 'Peru',
  [countryCodes.PAKISTAN.alphaTwo]: 'Pakistan',
  [countryCodes.PHILIPPINES.alphaTwo]: 'Philippines',
  [countryCodes.PITCAIRN.alphaTwo]: 'Pitcairn',
  [countryCodes.POLAND.alphaTwo]: 'Poland',
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: 'Saint Pierre and Miquelon',
  [countryCodes.ZAMBIA.alphaTwo]: 'Zambia',
  [countryCodes.WESTERN_SAHARA.alphaTwo]: 'Western Sahara',
  [countryCodes.ESTONIA.alphaTwo]: 'Estonia',
  [countryCodes.EGYPT.alphaTwo]: 'Egypt',
  [countryCodes.SOUTH_AFRICA.alphaTwo]: 'South Africa',
  [countryCodes.ECUADOR.alphaTwo]: 'Ecuador',
  [countryCodes.ITALY.alphaTwo]: 'Italy',
  [countryCodes.VIETNAM.alphaTwo]: 'Vietnam',
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: 'Solomon Islands',
  [countryCodes.ETHIOPIA.alphaTwo]: 'Ethiopia',
  [countryCodes.SOMALIA.alphaTwo]: 'Somalia',
  [countryCodes.ZIMBABWE.alphaTwo]: 'Zimbabwe',
  [countryCodes.SAUDI_ARABIA.alphaTwo]: 'Saudi Arabia',
  [countryCodes.SPAIN.alphaTwo]: 'Spain',
  [countryCodes.ERITREA.alphaTwo]: 'Eritrea',
  [countryCodes.MONTENEGRO.alphaTwo]: 'Montenegro',
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: 'Moldova',
  [countryCodes.MADAGASCAR.alphaTwo]: 'Madagascar',
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: 'Saint Martin',
  [countryCodes.MOROCCO.alphaTwo]: 'Morocco',
  [countryCodes.MONACO.alphaTwo]: 'Monaco',
  [countryCodes.UZBEKISTAN.alphaTwo]: 'Uzbekistan',
  [countryCodes.MYANMAR.alphaTwo]: 'Myanmar',
  [countryCodes.MALI.alphaTwo]: 'Mali',
  [countryCodes.MACAU.alphaTwo]: 'Macao',
  [countryCodes.MONGOLIA.alphaTwo]: 'Mongolia',
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: 'Marshall Islands',
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: 'Macedonia',
  [countryCodes.MAURITIUS.alphaTwo]: 'Mauritius',
  [countryCodes.MALTA.alphaTwo]: 'Malta',
  [countryCodes.MALAWI.alphaTwo]: 'Malawi',
  [countryCodes.MALDIVES.alphaTwo]: 'Maldives',
  [countryCodes.MARTINIQUE.alphaTwo]: 'Martinique',
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: 'Northern Mariana Islands',
  [countryCodes.MONTSERRAT.alphaTwo]: 'Montserrat',
  [countryCodes.MAURITANIA.alphaTwo]: 'Mauritania',
  [countryCodes.ISLE_OF_MAN.alphaTwo]: 'Isle of Man',
  [countryCodes.UGANDA.alphaTwo]: 'Uganda',
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: 'Tanzania',
  [countryCodes.MALAYSIA.alphaTwo]: 'Malaysia',
  [countryCodes.MEXICO.alphaTwo]: 'Mexico',
  [countryCodes.ISRAEL.alphaTwo]: 'Israel',
  [countryCodes.FRANCE.alphaTwo]: 'France',
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: 'British Indian Ocean Territory',
  [countryCodes.SAINT_HELENA.alphaTwo]: 'Saint Helena',
  [countryCodes.FINLAND.alphaTwo]: 'Finland',
  [countryCodes.FIJI.alphaTwo]: 'Fiji',
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: 'Falkland Islands',
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: 'Micronesia',
  [countryCodes.FAROE_ISLANDS.alphaTwo]: 'Faroe Islands',
  [countryCodes.NICARAGUA.alphaTwo]: 'Nicaragua',
  [countryCodes.NETHERLANDS.alphaTwo]: 'Netherlands',
  [countryCodes.NORWAY.alphaTwo]: 'Norway',
  [countryCodes.NAMIBIA.alphaTwo]: 'Namibia',
  [countryCodes.VANUATU.alphaTwo]: 'Vanuatu',
  [countryCodes.NEW_CALEDONIA.alphaTwo]: 'New Caledonia',
  [countryCodes.NIGER.alphaTwo]: 'Niger',
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: 'Norfolk Island',
  [countryCodes.NIGERIA.alphaTwo]: 'Nigeria',
  [countryCodes.NEW_ZEALAND.alphaTwo]: 'New Zealand',
  [countryCodes.NEPAL.alphaTwo]: 'Nepal',
  [countryCodes.NAURU.alphaTwo]: 'Nauru',
  [countryCodes.NIUE.alphaTwo]: 'Niue',
  [countryCodes.COOK_ISLANDS.alphaTwo]: 'Cook Islands',
  [countryCodes.KOSOVO.alphaTwo]: 'Kosovo',
  [countryCodes.COTE_DIVOIRE.alphaTwo]: 'Ivory Coast',
  [countryCodes.SWITZERLAND.alphaTwo]: 'Switzerland',
  [countryCodes.COLOMBIA.alphaTwo]: 'Colombia',
  [countryCodes.CHINA.alphaTwo]: 'China',
  [countryCodes.CAMEROON.alphaTwo]: 'Cameroon',
  [countryCodes.CHILE.alphaTwo]: 'Chile',
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: 'Cocos Islands',
  [countryCodes.CANADA.alphaTwo]: 'Canada',
  [countryCodes.CONGO.alphaTwo]: 'Republic of the Congo',
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: 'Central African Republic',
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: 'Democratic Republic of the Congo',
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: 'Czech Republic',
  [countryCodes.CYPRUS.alphaTwo]: 'Cyprus',
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: 'Christmas Island',
  [countryCodes.COSTA_RICA.alphaTwo]: 'Costa Rica',
  [countryCodes.CURACAO.alphaTwo]: 'Curacao',
  [countryCodes.CAPE_VERDE.alphaTwo]: 'Cape Verde',
  [countryCodes.CUBA.alphaTwo]: 'Cuba',
  [countryCodes.SWAZILAND.alphaTwo]: 'Swaziland',
  [countryCodes.SYRIA.alphaTwo]: 'Syria',
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: 'Sint Maarten',
  [countryCodes.KYRGYZSTAN.alphaTwo]: 'Kyrgyzstan',
  [countryCodes.KENYA.alphaTwo]: 'Kenya',
  [countryCodes.SOUTH_SUDAN.alphaTwo]: 'South Sudan',
  [countryCodes.SURINAME.alphaTwo]: 'Suriname',
  [countryCodes.KIRIBATI.alphaTwo]: 'Kiribati',
  [countryCodes.CAMBODIA.alphaTwo]: 'Cambodia',
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: 'Saint Kitts and Nevis',
  [countryCodes.COMOROS.alphaTwo]: 'Comoros',
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: 'Sao Tome and Principe',
  [countryCodes.SLOVAKIA.alphaTwo]: 'Slovakia',
  [countryCodes.SOUTH_KOREA.alphaTwo]: 'South Korea',
  [countryCodes.SLOVENIA.alphaTwo]: 'Slovenia',
  [countryCodes.NORTH_KOREA.alphaTwo]: 'North Korea',
  [countryCodes.KUWAIT.alphaTwo]: 'Kuwait',
  [countryCodes.SENEGAL.alphaTwo]: 'Senegal',
  [countryCodes.SAN_MARINO.alphaTwo]: 'San Marino',
  [countryCodes.SIERRA_LEONE.alphaTwo]: 'Sierra Leone',
  [countryCodes.SEYCHELLES.alphaTwo]: 'Seychelles',
  [countryCodes.KAZAKHSTAN.alphaTwo]: 'Kazakhstan',
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: 'Cayman Islands',
  [countryCodes.SINGAPORE.alphaTwo]: 'Singapore',
  [countryCodes.SWEDEN.alphaTwo]: 'Sweden',
  [countryCodes.SUDAN.alphaTwo]: 'Sudan',
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: 'Dominican Republic',
  [countryCodes.DOMINICA.alphaTwo]: 'Dominica',
  [countryCodes.DJIBOUTI.alphaTwo]: 'Djibouti',
  [countryCodes.DENMARK.alphaTwo]: 'Denmark',
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: 'British Virgin Islands',
  [countryCodes.GERMANY.alphaTwo]: 'Germany',
  [countryCodes.YEMEN.alphaTwo]: 'Yemen',
  [countryCodes.ALGERIA.alphaTwo]: 'Algeria',
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: 'United States',
  [countryCodes.URUGUAY.alphaTwo]: 'Uruguay',
  [countryCodes.MAYOTTE.alphaTwo]: 'Mayotte',
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: 'United States Minor Outlying Islands',
  [countryCodes.LEBANON.alphaTwo]: 'Lebanon',
  [countryCodes.SAINT_LUCIA.alphaTwo]: 'Saint Lucia',
  [countryCodes.LAOS.alphaTwo]: 'Laos',
  [countryCodes.TUVALU.alphaTwo]: 'Tuvalu',
  [countryCodes.TAIWAN.alphaTwo]: 'Taiwan',
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: 'Trinidad and Tobago',
  [countryCodes.TURKEY.alphaTwo]: 'Turkey',
  [countryCodes.SRI_LANKA.alphaTwo]: 'Sri Lanka',
  [countryCodes.LIECHTENSTEIN.alphaTwo]: 'Liechtenstein',
  [countryCodes.LATVIA.alphaTwo]: 'Latvia',
  [countryCodes.TONGA.alphaTwo]: 'Tonga',
  [countryCodes.LITHUANIA.alphaTwo]: 'Lithuania',
  [countryCodes.LUXEMBOURG.alphaTwo]: 'Luxembourg',
  [countryCodes.LIBERIA.alphaTwo]: 'Liberia',
  [countryCodes.LESOTHO.alphaTwo]: 'Lesotho',
  [countryCodes.THAILAND.alphaTwo]: 'Thailand',
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: 'French Southern Territories',
  [countryCodes.TOGO.alphaTwo]: 'Togo',
  [countryCodes.CHAD.alphaTwo]: 'Chad',
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: 'Turks and Caicos Islands',
  [countryCodes.LIBYA.alphaTwo]: 'Libya',
  [countryCodes.VATICAN.alphaTwo]: 'Vatican',
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: 'Saint Vincent and the Grenadines',
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: 'United Arab Emirates',
  [countryCodes.ANDORRA.alphaTwo]: 'Andorra',
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: 'Antigua and Barbuda',
  [countryCodes.AFGHANISTAN.alphaTwo]: 'Afghanistan',
  [countryCodes.ANGUILLA.alphaTwo]: 'Anguilla',
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: 'U.S. Virgin Islands',
  [countryCodes.ICELAND.alphaTwo]: 'Iceland',
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: 'Iran',
  [countryCodes.ARMENIA.alphaTwo]: 'Armenia',
  [countryCodes.ALBANIA.alphaTwo]: 'Albania',
  [countryCodes.ANGOLA.alphaTwo]: 'Angola',
  [countryCodes.ANTARCTICA.alphaTwo]: 'Antarctica',
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: 'American Samoa',
  [countryCodes.ARGENTINA.alphaTwo]: 'Argentina',
  [countryCodes.AUSTRALIA.alphaTwo]: 'Australia',
  [countryCodes.AUSTRIA.alphaTwo]: 'Austria',
  [countryCodes.ARUBA.alphaTwo]: 'Aruba',
  [countryCodes.INDIA.alphaTwo]: 'India',
  [countryCodes.ALAND_ISLANDS.alphaTwo]: 'Aland Islands',
  [countryCodes.AZERBAIJAN.alphaTwo]: 'Azerbaijan',
  [countryCodes.IRELAND.alphaTwo]: 'Ireland',
  [countryCodes.INDONESIA.alphaTwo]: 'Indonesia',
  [countryCodes.UKRAINE.alphaTwo]: 'Ukraine',
  [countryCodes.QATAR.alphaTwo]: 'Qatar',
  [countryCodes.MOZAMBIQUE.alphaTwo]: 'Mozambique',
});
